import React from 'react'
import styled from 'styled-components'

import FontAwesome from './fontawesome'
import Link from './link'

import { browserNavigator } from '../utils'

const Aside = styled.aside`
  align-items: center;
  background-color: #f6f7f7;
  bottom: 0;
  display: flex;
  height: 64px;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 100;

  @media only screen and (min-width: 45rem) {
    background-color: transparent;
    left: calc(((100% - 1080px) / 2) - 2rem);
    top: 30%;
    width: 0;
  }
`

const ShareBar = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin: 0 auto;
  position: sticky;
  z-index: 100;

  @media only screen and (min-width: 45rem) {
    flex-flow: column nowrap;
  }
`

const ShareLink = styled(Link)`
  margin: 1rem 1.5rem 1rem 0;

  :last-child {
    margin-right: 0;
  }

  @media only screen and (min-width: 45rem) {
    :last-child {
      margin-right: 1.5rem;
    }
  }
`

const ShareButton = styled.button`
  background: transparent;
  border: none;
  margin: 1rem 0 1rem 0;

  :active,
  :focus,
  :hover {
    cursor: pointer;
    outline: none;
  }

  @media only screen and (min-width: 45rem) {
    margin-right: 1.5rem;
  }
`

const Sidebar = ({ title, description, url }) => {
  const share = async (title, text, url) => {
    try {
      await browserNavigator.share({ title, text, url })
    } catch (error) {
      console.log(error)
      return
    }
  }

  let SharingAPI = null
  if (browserNavigator && browserNavigator.share) {
    SharingAPI = event => share(title, description, url)
  }

  return (
    <Aside>
      <ShareBar>
        <ShareLink
          alt={'Share this page on Facebook'}
          aria-label={'Share on Facebook'}
          className={'fb-xfbml-parse-ignore'}
          data-href={url}
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            url
          )}&amp;src=sdkpreparse`}
          rel={'noopener'}
          target={`_blank`}
        >
          <FontAwesome
            alt={'Icon for sharing this page on Facebook'}
            ariaLabel={'Share on Facebook Icon'}
            className={'social'}
            icon={['fab', 'facebook']}
            size={'2x'}
          />
        </ShareLink>
        <ShareLink
          alt={'Share this page on Twitter'}
          aria-label={'Share on Twitter'}
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
            description
          )}&url=${encodeURIComponent(url)}`}
          rel={'noopener'}
          target={`_blank`}
        >
          <FontAwesome
            alt={'Icon for sharing this page on Twitter'}
            ariaLabel={'Share on Twitter Icon'}
            className={'social'}
            icon={['fab', 'twitter']}
            size={'2x'}
          />
        </ShareLink>
        <ShareLink
          alt={'Share this page on LinkedIn'}
          aria-label={'Share on LinkedIn'}
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
            url
          )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(
            description
          )}&source=getroute.com`}
          rel={'noopener'}
          target={`_blank`}
        >
          <FontAwesome
            alt={'Icon for sharing this page on LinkedIn'}
            ariaLabel={'Share on LinkedIn Icon'}
            className={'social'}
            icon={['fab', 'linkedin-in']}
            size={'2x'}
          />
        </ShareLink>
        <ShareLink
          alt={'Share this page via Email'}
          aria-label={'Share via Email'}
          href={`mailto:?subject=${title}&body=${description}\n${url}`}
          rel={'noopener'}
          target={`_blank`}
        >
          <FontAwesome
            alt={'Icon for sharing this page via Email'}
            ariaLabel={'Share via Email Icon'}
            className={'social'}
            icon={['fas', 'envelope']}
            size={'2x'}
          />
        </ShareLink>

        {SharingAPI && (
          <ShareButton
            alt={'Share this page'}
            aria-label={'Share'}
            onClick={SharingAPI}
            rel={'noopener'}
          >
            <FontAwesome
              alt={'Icon for sharing this page'}
              ariaLabel={'Share Icon'}
              className={'social'}
              icon={['fas', 'share-alt']}
              size={'2x'}
            />
          </ShareButton>
        )}
      </ShareBar>
    </Aside>
  )
}

export default Sidebar
